import { useEffect } from 'react';
import { useParams } from 'react-router-dom';
import qs from 'query-string';

import { Processing } from '../components/processing';
import client from '../services/client';
import { useInvoice } from '../services/use-invoice';
import { useAppContext } from '../stores/app-context';
import { useDedupedCallback } from '../utils/use-deduped-callback';

export const AuthJKOPay = () => {
  const { invoiceId } = useParams();
  const isInvoiceIdValid = typeof invoiceId === 'string';

  const { onToastError } = useAppContext();

  const { invoice, refetch } = useInvoice(
    { invoiceId },
    {
      enabled: isInvoiceIdValid,
    },
  );

  const hashData = qs.parse(window.location.hash);

  const { merchant_transaction_id } = hashData as {
    merchant_transaction_id: string;
  };

  const confirmCreditCardTransaction = useDedupedCallback(async () => {
    try {
      await client.confirmJKOPayTransaction({
        transactionId: merchant_transaction_id,
      });
    } catch (err) {
      onToastError(err.message);
    } finally {
      refetch();
    }
  }, [merchant_transaction_id, invoiceId, invoice, refetch]);

  useEffect(() => {
    if (invoice.payment_state === 'paid') {
      return;
    }

    // prevent execute the identical transaction twice
    confirmCreditCardTransaction();
  }, [confirmCreditCardTransaction, invoice.payment_state]);
  return <Processing />;
};
